// Auth mappers - convert snake_case API responses to camelCase

import type { 
  AuthResponseRaw,
  AuthResponse,
  UserProfile 
} from '../types/auth.types';

const ROLE_MAP: Record<number, string> = {
  0: 'superadmin',
  1: 'admin',
  2: 'manager',
  3: 'operator',
  4: 'viewer',
};

export function mapClientAuthResponse(raw: AuthResponseRaw): AuthResponse {
  // Support both snake_case and camelCase just in case
  const accessToken = raw?.access_token ?? raw?.accessToken ?? '';
  const refreshToken = raw?.refresh_token ?? raw?.refreshToken ?? '';
  const expiresAtIso = raw?.expires_at ?? raw?.expiresAt;

  const expiresIn = typeof raw?.expires_in === 'number'
    ? raw.expires_in
    : expiresAtIso
      ? Math.max(0, Math.floor((new Date(expiresAtIso).getTime() - Date.now()) / 1000))
      : 3600;

  const userRaw = raw?.user ?? {};
  const orgRaw = raw?.organization ?? {};

  const firstName = userRaw?.first_name ?? userRaw?.firstName ?? '';
  const lastName = userRaw?.last_name ?? userRaw?.lastName ?? '';
  const fullName = `${firstName} ${lastName}`.trim();
  const roleValue = userRaw?.role;
  const role = typeof roleValue === 'number' ? (ROLE_MAP[roleValue] ?? 'unknown') : (typeof roleValue === 'string' ? roleValue : 'unknown');

  return {
    accessToken,
    refreshToken,
    expiresIn,
    user: {
      id: userRaw?.id ?? '',
      email: userRaw?.email ?? '',
      fullName,
      avatarUrl: userRaw?.avatar_url ?? userRaw?.avatarUrl,
      organizationId: orgRaw?.id ?? '',
      organizationName: orgRaw?.name ?? '',
      role,
      emailVerified: !!(userRaw?.email_verified ?? userRaw?.emailVerified),
    },
  };
}